/*=========================================================================================
  File Name: moduleApicilActions.js
  Description: Apicil Module Actions
==========================================================================================*/


export default {
	SetProjectId({
		commit
	}, payload) {
		commit('SET_PROJECTID', payload);
	},
	SetEtatCivilFirstName({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_FIRSTNAME', payload);
	},
	SetEtatCivilLastName({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_LASTNAME', payload);
	},
	SetEtatCivilBirthLastName({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHLASTNAME', payload);
	},
	SetEtatCivilCivility({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_CIVILITY', payload);
	},
	SetEtatCivilDateOfBirth({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_DATEOFBIRTH', payload);
	},
	SetEtatCivilBirthCity({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHCITY', payload);
	},
	SetEtatCivilBirthState({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHSTATE', payload);
	},
	SetEtatCivilBirthDeptNum({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHDEPTNUM', payload);
	},
	SetEtatCivilBirthCountry({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHCOUNTRY', payload);
	},
	SetEtatCivilNationality({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_NATIONALITY', payload);
	},
	SetContactInfoAddress({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_ADDRESS', payload);
	},
	SetContactInfoAddressComp({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_ADDRESSCOMP', payload);
	},
	SetContactInfoZipCode({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_ZIPCODE', payload);
	},
	SetContactInfoCity({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_CITY', payload);
	},
	SetContactInfoCountry({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_COUNTRY', payload);
	},
	SetContactInfoEmail({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_EMAIL', payload);
	},
	SetContactInfoMobileTel({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_MOBILETEL', payload);
	},
	SetContactInfoHomeTel({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_HOMETEL', payload);
	},
	SetContactInfoMobileTelFormatted({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_MOBILETELFORMATTED', payload);
	},
	SetContactInfoHomeTelFormatted({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_HOMETELFORMATTED', payload);
	},
	SetContactInfoMobileTelIndicatif({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_MOBILETELINDICATIF', payload);
	},
	SetContactInfoHomeTelIndicatif({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_HOMETELINDICATIF', payload);
	},

	SetResidenceFiscaleAdresseFiscaleSame({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_ADRESSEFISCALESAME', payload);
	},

	SetResidenceFiscaleIsAmericanSubject({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_ISAMERICANSUBJECT', payload);
	},
	SetResidenceFiscaleIsForeignSubject({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_ISFOREIGNSUBJECT', payload);
	},
	SetResidenceFiscaleHasTin({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_HASTIN', payload);
	},
	SetResidenceFiscaleNif({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_NIF', payload);
	},
	SetResidenceFiscaleTin({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_TIN', payload);
	},
	SetResidenceFiscaleNifCountry({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_NIFCOUNTRY', payload);
	},
	SetSituationFamilialeFamSituation({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_FAMSITUATION', payload);
	},
	SetSituationFamilialeRegimeMatrimonial({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_REGIMEMATRIMONIAL', payload);
	},
	SetSituationFamilialePersonneACharge({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_PERSONNEACHARGE', payload);
	},
	SetSituationFamilialeHasRegimeMatrimonial({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_HASREGIMEMATRIMONIAL', payload);
	},
	SetSituationFamilialeHasConjoint({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_HASCONJOINT', payload);
	},
	SetConjointEtatCivilFirstName({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_FIRSTNAME', payload);
	},
	SetConjointEtatCivilLastName({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_LASTNAME', payload);
	},
	SetConjointEtatCivilBirthLastName({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHLASTNAME', payload);
	},
	SetConjointEtatCivilCivility({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_CIVILITY', payload);
	},
	SetConjointEtatCivilDateOfBirth({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_DATEOFBIRTH', payload);
	},
	SetConjointEtatCivilBirthCIty({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHCITY', payload);
	},
	SetConjointEtatCivilBirthState({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHSTATE', payload);
	},
	SetConjointEtatCivilBirthDeptNum({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHDEPTNUM', payload);
	},
	SetConjointEtatCivilBirthCountry({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHCOUNTRY', payload);
	},
	SetConjointEtatCivilNationality({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_NATIONALITY', payload);
	},
	SetRevenues({
		commit
	}, payload) {
		commit('SET_REVENUES', payload);
	},
	SetPatrimoine({
		commit
	}, payload) {
		commit('SET_PRTIMOINE', payload);
	},
	AddToRevenues({
		commit
	}, payload) {
		commit('ADD_TO_REVENUES', payload);
	},
	AddToPatrimoine({
		commit
	}, payload) {
		commit('ADD_TO_PRTIMOINE', payload);
	},
	SetUserComments({
		commit
	}, payload) {
		commit('SET_USERCOMMENTS', payload);
	},
	SetHasComments({
		commit
	}, payload) {
		commit('SET_HASCOMMENTS', payload);
	},
	RemoveFromRevenues({
		commit
	}, payload) {
		commit('REMOVE_FROMREVENUES', payload);
	},
	RemoveFromPatrimoine({
		commit
	}, payload) {
		commit('REMOVE_FROMPATRIMOINE', payload);
	},
	SetProsituation({
		commit
	}, payload) {
		commit('SET_PROSITUATION', payload);
	},
	SetConjointProsituation({
		commit
	}, payload) {
		commit('SET_CONJOINT_PROSITUATION', payload);
	},
	SetIsNonSalarie({
		commit
	}, payload) {
		commit('SET_ISNONSALARIE', payload);
	},
	SetConjointIsNonSalarie({
		commit
	}, payload) {
		commit('SET_CONJOINT_ISNONSALARIE', payload);
	},
	SetIsPPE({
		commit
	}, payload) {
		commit('SET_ISPPE', payload);
	},
	SetConjointIsPPE({
		commit
	}, payload) {
		commit('SET_CONJOINT_ISPPE', payload);
	},
	SetIsRelatedToPPE({
		commit
	}, payload) {
		commit('SET_ISRELATEDTOPPE', payload);
	},
	SetConjointIsRelatedToPPE({
		commit
	}, payload) {
		commit('SET_CONJOINT_ISRELATEDTOPPE', payload);
	},
	SetProActuelle({
		commit
	}, payload) {
		commit('SET_PROACTUELLE', payload);
	},
	SetConjointProActuelle({
		commit
	}, payload) {
		commit('SET_CONJOINT_PROACTUELLE', payload);
	},
	SetCompanyName({
		commit
	}, payload) {
		commit('SET_COMPANYNAME', payload);
	},
	SetConjointCompanyName({
		commit
	}, payload) {
		commit('SET_CONJOINT_COMPANYNAME', payload);
	},
	SetSocioProCat({
		commit
	}, payload) {
		commit('SET_SOCIOPROCAT', payload);
	},
	SetConjointSocioProCat({
		commit
	}, payload) {
		commit('SET_CONJOINT_SOCIOPROCAT', payload);
	},
	SetActivitySector({
		commit
	}, payload) {
		commit('SET_ACTIVITYSECTOR', payload);
	},
	SetConjointActivitySector({
		commit
	}, payload) {
		commit('SET_CONJOINT_ACTIVITYSECTOR', payload);
	},
	SetPpeFonction({
		commit
	}, payload) {
		commit('SET_PPEFONCTION', payload);
	},
	SetConjointPpeFonction({
		commit
	}, payload) {
		commit('SET_CONJOINT_PPEFONCTION', payload);
	},
	SetPpeCountry({
		commit
	}, payload) {
		commit('SET_PPECOUNTRY', payload);
	},
	SetConjointPpeCountry({
		commit
	}, payload) {
		commit('SET_CONJOINT_PPECOUNTRY', payload);
	},
	SetPpeCountryVal({
		commit
	}, payload) {
		commit('SET_PPECOUNTRYVAL', payload);
	},
	SetConjointPpeCountryVal({
		commit
	}, payload) {
		commit('SET_CONJOINT_PPECOUNTRYVAL', payload);
	},
	SetRelatedPpeCountry({
		commit
	}, payload) {
		commit('SET_RELATEDPPECOUNTRY', payload);
	},
	SetConjointRelatedPpeCountry({
		commit
	}, payload) {
		commit('SET_CONJOINT_RELATEDPPECOUNTRY', payload);
	},
	SetRelatedPpeCountryVal({
		commit
	}, payload) {
		commit('SET_RELATEDPPECOUNTRYVAL', payload);
	},
	SetConjointRelatedPpeCountryVal({
		commit
	}, payload) {
		commit('SET_CONJOINT_RELATEDPPECOUNTRYVAL', payload);
	},
	SetPpeRelation({
		commit
	}, payload) {
		commit('SET_PPERELATION', payload);
	},
	SetConjointPpeRelation({
		commit
	}, payload) {
		commit('SET_CONJOINT_PPERELATION', payload);
	},
	SetRelatedPpeFonction({
		commit
	}, payload) {
		commit('SET_RELATEDPPEFONCTION', payload);
	},
	SetConjointRelatedPpeFonction({
		commit
	}, payload) {
		commit('SET_CONJOINT_RELATEDPPEFONCTION', payload);
	},
	SetPpeLastName({
		commit
	}, payload) {
		commit('SET_PPELASTNAME', payload);
	},
	SetConjointPpeLastName({
		commit
	}, payload) {
		commit('SET_CONJOINT_PPELASTNAME', payload);
	},
	SetPpeFirstName({
		commit
	}, payload) {
		commit('SET_PPEFIRSTNAME', payload);
	},
	SetConjointPpeFirstName({
		commit
	}, payload) {
		commit('SET_CONJOINT_PPEFIRSTNAME', payload);
	},
	SetStep1IsValid({
		commit
	}, payload) {
		commit('SET_STEP1_ISVALID', payload);
	},
	SetStep({
		commit
	}, payload) {
		commit('SET_STEP', payload);
	},
	SetResidenceFiscaleContactInfoAddress({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESS', payload);
	},
	SetResidenceFiscaleContactInfoAddressComp({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESSCOMP', payload);
	},
	SetResidenceFiscaleContactInfoZipCode({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_ZIPCODE', payload);
	},
	SetResidenceFiscaleContactInfoCity({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_CITY', payload);
	},
	SetResidenceFiscaleContactInfoCountry({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_COUNTRY', payload);
	},
	SetSelectedProduct({
		commit
	}, payload) {
		commit('SET_SELECTEDPRODUCT', payload);
	},
	SetSelectedModeGestion({
		commit
	}, payload) {
		commit('SET_SELECTEDMODEGESTION', payload);
	},
	SetSelectedOrientationGestion({
		commit
	}, payload) {
		commit('SET_SELECTEDORIENTATIONGESTION', payload);
	},
	SetSelectedSocieteGestion({
		commit
	}, payload) {
		commit('SET_SELECTEDSOCIETEGESTION', payload);
	},
	SetIsSpecifique({
		commit
	}, payload) {
		commit('SET_ISSPECIFIQUE', payload);
	},
	SetIsAdhesionVictoria({
		commit
	}, payload) {
		commit('SET_ISADHESIONVICTORIA', payload);
	},
	SetIsEpargneHandicap({
		commit
	}, payload) {
		commit('SET_ISEPARGNEHANDICAP', payload);
	},
	SetIsCoSouscriptionDemenbree({
		commit
	}, payload) {
		commit('SET_ISCOSOUSCRIPTIONDEMENBREE', payload);
	},
	SetIsSouscriptionMajeurSousTutelle({
		commit
	}, payload) {
		commit('SET_ISSOUSCRIPTIONMAJEURSOUSTUTELLE', payload);
	},
	SetIsSouscriptionMajeurSousCuratelle({
		commit
	}, payload) {
		commit('SET_ISSOUSCRIPTIONMAJEURSOUSCURATELLE', payload);
	},
	SetIsPacteAdjointADonManuel({
		commit
	}, payload) {
		commit('SET_ISPACTEADJOINTADONMANUEL', payload);
	},
	SetIsCoSouscription({
		commit
	}, payload) {
		commit('SET_ISCOSOUSCRIPTION', payload);
	},
	SetIsContratEnFondsPropres({
		commit
	}, payload) {
		commit('SET_ISCONTRATENFONDSPROPRES', payload);
	},
	SetIsSignatureElectronique({
		commit
	}, payload) {
		commit('SET_ISSIGNATUREELECTRONIQUE', payload);
	},
	SetIsSignaturePapier({
		commit
	}, payload) {
		commit('SET_ISSIGNATUREPAPIER', payload);
	},
	SetObjectifInvest({
		commit
	}, payload) {
		commit('SET_OBJECTIFINVEST', payload);
	},
	SetDureeInvest({
		commit
	}, payload) {
		commit('SET_DUREEINVEST', payload);
	},
	SetDureeInvestVal({
		commit
	}, payload) {
		commit('SET_DUREEINVESTVAL', payload);
	},
	SetHasGarantiePlancher({
		commit
	}, payload) {
		commit('SET_HASGARANTIEPLANCHER', payload);
	},
	SetHasVersementProgramme({
		commit
	}, payload) {
		commit('SET_HASVERSEMENTPROGRAMME', payload);
	},
	SetVersementProgrammePeriodiciteVersement({
		commit
	}, payload) {
		commit('SET_VERSEMENTPROGRAMME_PERIODICITEVERSEMENT', payload);
	},
	SetVersementProgrammeMontantVersement({
		commit
	}, payload) {
		commit('SET_VERSEMENTPROGRAMME_MONTANTVERSEMENT', payload);
	},
	SetMontantVersementInitial({
		commit
	}, payload) {
		commit('SET_MONTANTVERSEMENTINITIAL', payload);
	},
	SetPaymentFromSubscriber({
		commit
	}, payload) {
		commit('SET_PAYMENTFROMSUBSCRIBER', payload);
	},
	SetPayeurContactInfoLienParente({
		commit
	}, payload) {
		commit('SET_PAYEURCONTACTINFO_LIENPARENTE', payload);
	},
	SetPayeurContactInfoFirstName({
		commit
	}, payload) {
		commit('SET_PAYEURCONTACTINFO_FIRSTNAME', payload);
	},
	SetPayeurContactInfoLastName({
		commit
	}, payload) {
		commit('SET_PAYEURCONTACTINFO_LASTNAME', payload);
	},
	SetPayeurContactInfoBirthCity({
		commit
	}, payload) {
		commit('SET_PAYEURCONTACTINFO_BIRTHCITY', payload);
	},
	SetPayeurContactInfoDateOfBirth({
		commit
	}, payload) {
		commit('SET_PAYEURCONTACTINFO_DATEOFBIRTH', payload);
	},
	SetModePaiement({
		commit
	}, payload) {
		commit('SET_MODEPAIEMENT', payload);
	},
	SetDonneesBancairesTitulaire({
		commit
	}, payload) {
		commit('SET_DONNEESBANCAIRES_TITULAIRE', payload);
	},
	SetDonneesBancairesIBAN({
		commit
	}, payload) {
		commit('SET_DONNEESBANCAIRES_IBAN', payload);
	},
	SetDonneesBancairesBIC({
		commit
	}, payload) {
		commit('SET_DONNEESBANCAIRES_BIC', payload);
	},
	SetOrigineFondsTransfertPlacement({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_TRANSFERTPLACEMENT', payload);
	},
	SetOrigineFondsCessionActifsPro({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_CESSIONACTIFSPRO', payload);
	},
	SetOrigineFondsVenteImmo({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_VENTEIMMO', payload);
	},
	SetOrigineFondsVenteBiensMobiliers({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_VENTEBIENSMOBILIERS', payload);
	},
	SetOrigineFondsSuccessionOuDonation({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_SUCCESSIONOUDONATION', payload);
	},
	SetOrigineFondsRevenusPro({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_REVENUSPRO', payload);
	},
	SetOrigineFondsAutresOrigines({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_AUTRESORIGINES', payload);
	},
	SetOrigineFondsCommentaireAutres({
		commit
	}, payload) {
		commit('SET_ORIGINEFONDS_COMMENTAIREAUTRES', payload);
	},
	SetClauseBeneficiaire({
		commit
	}, payload) {
		commit('SET_CLAUSEBENEFICIAIRE', payload);
	},
	SetNotaireContactInfoFirstName({
		commit
	}, payload) {
		commit('SET_NOTAIRECONTACTINFO_FIRSTNAME', payload);
	},
	SetNotaireContactInfoLastName({
		commit
	}, payload) {
		commit('SET_NOTAIRECONTACTINFO_LASTNAME', payload);
	},
	SetNotaireContactInfoZipCode({
		commit
	}, payload) {
		commit('SET_NOTAIRECONTACTINFO_ZIPCODE', payload);
	},
	SetNotaireContactInfoCity({
		commit
	}, payload) {
		commit('SET_NOTAIRECONTACTINFO_CITY', payload);
	},
	SetVersementInitialMinimum({
		commit
	}, payload) {
		commit('SET_VERSEMENTINITIALMINIMUM', payload);
	},
	SetResteAJustifie({
		commit
	}, payload) {
		commit('SET_RESTEAJUSTIFIE', payload);
	},
	SetProjectData({
		commit
	}, payload) {
		commit('SET_PROJECT_DATA', payload);
	},
};